<template lang="">
  <v-card elevation="2" class="ma-0 overflow-auto" :style="`height: ${height} !important`" :loading="loading" eager>
    <v-card-title>
      <v-row align="center" justify="space-between" class="mx-auto" dense>
        <div>
          <v-icon large left>mdi-newspaper</v-icon>
          <span class="font-weight-light text-h5">Taxa WACC</span>
        </div>
        <div>
          <v-btn
            color="primary"
            :dark="formIsValid"
            elevation="1"
            relative
            text
            medium
            :disabled="!formIsValid"
            :loading="loading"
            @click="addRow()"
          >
            <v-icon left size="30px">mdi-plus-circle</v-icon>
            Nova Versão
          </v-btn>
        </div>
      </v-row>
    </v-card-title>
    <v-divider />
    <v-simple-table>
      <template v-slot:default>
        <thead class="v-data-table-header">
          <tr>
            <th class="pl-4 text-start" style="width: 20%">Versão do Submódulo</th>
            <th class="pl-4 text-start" style="width: 20%">Início vigência</th>
            <th class="pl-4 text-start" style="width: 20%">Fim vigência</th>
            <th class="pl-4 text-start" style="width: 25%">WACC Aprovada (%)</th>
            <th class="pl-4 text-start" style="width: 5%">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, _key) in items" :key="_key">
            <td class="pl-4 text-start">
              <validation-provider
                v-slot="{ errors }"
                :rules="`required|min_value:1|unique_values:${JSON.stringify(arrayVersoes)}`"
                immediate
              >
                <v-text-field
                  v-model="item.versao_submodulo"
                  label="Versão do Submódulo"
                  dense
                  :disabled="loading"
                  :error-messages="errors"
                />
              </validation-provider>
            </td>
            <td class="pl-4 text-start">
              <date-picker
                v-model="item.data_inicio_vigencia"
                label="Início Vigência"
                type="date"
                :rules="`required|data_vigencia_wacc_check:${item.versao_submodulo},${JSON.stringify(items)}`"
                :disabled="loading"
                immediateValidate
              />
            </td>
            <td class="pl-4 text-start">
              <template v-if="_key == 0">
                <label>até o momento</label>
              </template>
              <date-picker
                v-else
                v-model="item.data_fim_vigencia"
                label="Fim Vigência"
                type="date"
                :rules="`required|data_vigencia_wacc_check:${item.versao_submodulo},${JSON.stringify(items)}`"
                :disabled="loading"
                immediateValidate
              />
            </td>
            <td class="pl-4 text-start">
              <validation-provider v-slot="{ errors }" rules="required|min_value:0.0001" immediate>
                <v-text-field
                  v-model="item.percentual_wacc_aprovada"
                  label="WACC Aprovada %"
                  type="number"
                  min="0"
                  step="0.1"
                  dense
                  title=""
                  :disabled="loading"
                  :error-messages="errors"
                />
              </validation-provider>
            </td>
            <td class="pl-4 text-start">
              <v-btn
                class="ml-n1 px-1"
                min-width="0"
                fab
                icon
                x-small
                :disabled="loading"
                @click="openDialogDelete(_key, item.versao_submodulo)"
              >
                <v-icon small>mdi-trash-can-outline</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Deletar WACC Versão {{ dialogDeleteData.titulo }}</template>
      <template slot="body">
        Tem certeza que deseja deletar a WACC Versão
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>
  </v-card>
</template>
<script>
  import TaxaWaccService from '@/services/TaxaWaccService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
  import dayjs from 'dayjs';
  import utc from 'dayjs/plugin/utc';
  dayjs.extend(utc);

  export default {
    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      DatePicker: () => import('@/components/general/DatePicker.vue')
    },
    mixins: [powerupsActionsMixins],

    props: {
      height: {
        type: String,
        required: false,
        default: '400px' /* 400px || auto */
      },
      formIsValid: {
        type: Boolean,
        default: true
      }
    },

    data: () => ({
      powerupService: TaxaWaccService,
      powerupEntityName: 'Taxa WACC',
      headers: [
        {
          text: 'Versão do Submódulo',
          value: 'versao_submodulo'
        },
        {
          text: 'Início vigência',
          value: 'data_inicio_vigencia'
        },
        {
          text: 'Fim vigência',
          value: 'data_fim_vigencia'
        },
        {
          text: 'WACC Aprovada (%)',
          value: 'percentual_wacc_aprovada'
        },
        {
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      loading: false,
      items: []
    }),

    computed: {
      arrayVersoes() {
        return this.items.map((item) => item.versao_submodulo);
      }
    },

    created() {
      this.getAll();
    },

    methods: {
      getAll() {
        this.loading = true;

        TaxaWaccService.getAll()
          .then(({ data }) => {
            this.items = data.data;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error("Erro ao recuperar taxas wacc's.", '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },

      deletarItem(index) {
        this.items = this.items.filter((item, key) => key !== index);
        this.dialogDelete = false;
      },

      addRow() {
        this.items[0].data_fim_vigencia = null;
        this.items.unshift({
          versao_submodulo: null,
          data_inicio_vigencia: null,
          data_fim_vigencia: null,
          percentual_wacc_aprovada: null
        });
      },

      exportData() {
        const items = this.items.map((item, index) => {
          return {
            versao_submodulo: item.versao_submodulo.trim(),
            data_inicio_vigencia: dayjs(item.data_inicio_vigencia).utc().format('YYYY-MM-DD'),
            data_fim_vigencia: index !== 0 ? dayjs(item.data_fim_vigencia).utc().format('YYYY-MM-DD') : null,
            percentual_wacc_aprovada: item.percentual_wacc_aprovada
          };
        });

        return { taxa_wacc_vigentes: items };
      }
    }
  };
</script>

<style>
  .w-fit-content {
    width: fit-content !important;
  }
</style>
